import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=7329bf15"
import script from "./TagsList.vue?vue&type=script&lang=js"
export * from "./TagsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports